//request for availability broadcast
export const REQUEST_AVAILABILITY_BROADCAST = "REQUEST_AVAILABILITY_BROADCAST";
export const REQUEST_AVAILABILITY_BROADCAST_RECEIVE =
  "REQUEST_AVAILABILITY_BROADCAST_RECEIVE";
export const REQUEST_AVAILABILITY_BROADCAST_FAILURE =
  "REQUEST_AVAILABILITY_BROADCAST_FAILURE";
export const RESET_REQUEST_AVAILABILITY_BROADCAST =
  "RESET_REQUEST_AVAILABILITY_BROADCAST";

//withdraw availability broadcast
export const WITHDRAW_AVAILABILITY_BROADCAST =
  "WITHDRAW_AVAILABILITY_BROADCAST";
export const WITHDRAW_AVAILABILITY_BROADCAST_RECEIVE =
  "WITHDRAW_AVAILABILITY_BROADCAST_RECEIVE";
export const WITHDRAW_AVAILABILITY_BROADCAST_FAILURE =
  "WITHDRAW_AVAILABILITY_BROADCAST_FAILURE";
export const RESET_WITHDRAW_AVAILABILITY_BROADCAST =
  "RESET_WITHDRAW_AVAILABILITY_BROADCAST";

//Get all request for availability broadcast
export const GET_ALL_REQUEST_AVAILABILITY_BROADCAST =
  "GET_ALL_REQUEST_AVAILABILITY_BROADCAST";
export const GET_ALL_REQUEST_AVAILABILITY_BROADCAST_RECEIVE =
  "GET_ALL_REQUEST_AVAILABILITY_BROADCAST_RECEIVE";
export const GET_ALL_REQUEST_AVAILABILITY_BROADCAST_FAILURE =
  "GET_ALL_REQUEST_AVAILABILITY_BROADCAST_FAILURE";
export const RESET_GET_ALL_REQUEST_AVAILABILITY_BROADCAST =
  "RESET_GET_ALL_REQUEST_AVAILABILITY_BROADCAST";

//Favourite user
export const FAVORITE_USER = "FAVORITE_USER";
export const FAVORITE_USER_RECEIVE = "FAVORITE_USER_RECEIVE";
export const FAVORITE_USER_FAILURE = "FAVORITE_USER_FAILURE";

export const UNFAVORITE_USER = "UNFAVORITE_USER";
export const UNFAVORITE_USER_RECEIVE = "UNFAVORITE_USER_RECEIVE";
export const UNFAVORITE_USER_FAILURE = "UNFAVORITE_USER_FAILURE";

export const RESET_FAVORITE_USER = "RESET_FAVORITE_USER";

//Block user
export const BLOCK_USER = "BLOCK_USER";
export const BLOCK_USER_RECEIVE = "BLOCK_USER_RECEIVE";
export const BLOCK_USER_FAILURE = "BLOCK_USER_FAILURE";

export const UNBLOCK_USER = "UNBLOCK_USER";
export const UNBLOCK_USER_RECEIVE = "UNBLOCK_USER_RECEIVE";
export const UNBLOCK_USER_FAILURE = "UNBLOCK_USER_FAILURE";

export const RESET_BLOCK_USER = "RESET_BLOCK_USER";

//Remove availability requested by user
export const REMOVE_AVAILABILITY_REQUEST = "REMOVE_AVAILABILITY_REQUEST";
export const REMOVE_AVAILABILITY_REQUEST_RECEIVE =
  "REMOVE_AVAILABILITY_REQUEST_RECEIVE";
export const REMOVE_AVAILABILITY_REQUEST_FAILURE =
  "REMOVE_AVAILABILITY_REQUEST_FAILURE";
export const RESET_REMOVE_AVAILABILITY_REQUEST =
  "RESET_REMOVE_AVAILABILITY_REQUEST";

// One to One request call join avaialability by user
export const BROADCASTER_ACCEPT_REQUEST = "BROADCASTER_ACCEPT_REQUEST";
export const BROADCASTER_ACCEPT_REQUEST_RECEIVE =
  "BROADCASTER_ACCEPT_REQUEST_RECEIVE";
export const BROADCASTER_ACCEPT_REQUEST_FAILURE =
  "BROADCASTER_ACCEPT_REQUEST_FAILURE";
export const RESET_BROADCASTER_ACCEPT_REQUEST =
  "RESET_BROADCASTER_ACCEPT_REQUEST";

// Broadcaster Timeout Request
export const BROADCASTER_TIMEOUT_REQUEST = "BROADCASTER_TIMEOUT_REQUEST";
export const BROADCASTER_TIMEOUT_REQUEST_RECEIVE =
  "BROADCASTER_TIMEOUT_REQUEST_RECEIVE";
export const BROADCASTER_TIMEOUT_REQUEST_FAILURE =
  "BROADCASTER_TIMEOUT_REQUEST_FAILURE";
export const RESET_BROADCASTER_TIMEOUT_REQUEST =
  "RESET_BROADCASTER_TIMEOUT_REQUEST";
// Accept One to One request viewer dialog
export const SHOW_ACCEPT_ONE_TO_ONE_AVAILABILITY_REQ_DIALOG = "SHOW_ACCEPT_ONE_TO_ONE_AVAILABILITY_REQ_DIALOG";
export const HIDE_ACCEPT_ONE_TO_ONE_AVAILABILITY_REQ_DIALOG = "HIDE_ACCEPT_ONE_TO_ONE_AVAILABILITY_REQ_DIALOG";

// Get notification data
export const GET_NOTIFICATION_DATA = "GET_NOTIFICATION_DATA";
export const GET_NOTIFICATION_DATA_RECEIVE = "GET_NOTIFICATION_DATA_RECEIVE";
export const GET_NOTIFICATION_DATA_FAILURE = "GET_NOTIFICATION_DATA_FAILURE";
export const SET_NOTIFICATION_DATA_FROM_NOTIFICATION_PANEL = "SET_NOTIFICATION_DATA_FROM_NOTIFICATION_PANEL";
export const RESET_NOTIFICATION_DATA = "RESET_NOTIFICATION_DATA";

// Accept availability request
export const ACCEPT_AVAILABILITY_REQUEST = "ACCEPT_AVAILABILITY_REQUEST";
export const ACCEPT_AVAILABILITY_REQUEST_RECEIVE = "ACCEPT_AVAILABILITY_REQUEST_RECEIVE";
export const ACCEPT_AVAILABILITY_REQUEST_FAILURE = "ACCEPT_AVAILABILITY_REQUEST_FAILURE";
export const RESET_ACCEPT_AVAILABILITY_REQUEST = "RESET_ACCEPT_AVAILABILITY_REQUEST";
export const RESET_ACCEPT_AVAILABILITY_FLAG = "RESET_ACCEPT_AVAILABILITY_FLAG"

// Decline availability request
export const DECLINE_AVAILABILITY_REQUEST = "DECLINE_AVAILABILITY_REQUEST";
export const DECLINE_AVAILABILITY_REQUEST_RECEIVE = "DECLINE_AVAILABILITY_REQUEST_RECEIVE";
export const DECLINE_AVAILABILITY_REQUEST_FAILURE = "DECLINE_AVAILABILITY_REQUEST_FAILURE";
export const RESET_DECLINE_AVAILABILITY_REQUEST = "RESET_DECLINE_AVAILABILITY_REQUEST";


// One to one - Group request list
export const ONE_TO_ONE_AVAILABILITY_REQUEST_LIST = "ONE_TO_ONE_AVAILABILITY_REQUEST_LIST";
export const GROUP_AVAILABILITY_REQUEST_LIST = "GROUP_AVAILABILITY_REQUEST_LIST";
export const PRIVATE_AVAILABILITY_REQUEST_LIST = "PRIVATE_AVAILABILITY_REQUEST_LIST";
export const RESET_AVAILABILITY_REQUEST_LIST = "RESET_AVAILABILITY_REQUEST_LIST";
